import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/** <cadence-card heading="…"> with default slot for body and optional "actions" slot. */
@customElement('cadence-card')
export class CadenceCard extends LitElement {
  @property() heading = '';

  static styles = css`
    :host { display: block; }
    .card {
      background: var(--color-bg-primary); border: 1px solid var(--color-border);
      border-radius: var(--radius-lg); box-shadow: var(--shadow-md); overflow: hidden;
      display: flex; flex-direction: column; height: 100%;
    }
    .body { flex: 1; }
    header {
      display: flex; align-items: center; justify-content: space-between; gap: 12px;
      padding: var(--space-4) var(--space-5); border-bottom: 1px solid var(--color-border);
    }
    header h3 { margin: 0; font-size: 1rem; }
    .body { padding: var(--space-5); }
  `;

  render() {
    return html`
      <div class="card">
        ${this.heading
          ? html`<header><h3>${this.heading}</h3><slot name="actions"></slot></header>`
          : ''}
        <div class="body"><slot></slot></div>
      </div>
    `;
  }
}
